import EntryDto from '@/src/models/EntryDto';
import dayjs from 'dayjs';
import ko from 'dayjs/locale/ko';
import { boolean } from 'zod';

export interface EntryWebviewTemplate
  extends Partial<Omit<Omit<EntryDto, 'participantsCnt'>, 'entryCredit'>> {
  ddayText: string;
  myCredit: string;
  thumbnailImageBufferFullUrl: string;
  sponsorImageBufferFullUrl: string;
  infosList: string;
  cautionsList: string;
  ddayTextDisplayYn: boolean;
  thumbnailImageBufferFullUrlDisplayYn: boolean;
  subTitleDisplayYn: boolean;
  sponsorDividerDisplayYn: boolean;
  sponsorImageBufferFullUrlDisplayYn: boolean;
  sponsorDescriptionDisplayYn: boolean;
  sponsorPageLinkDisplayYn: boolean;
  infosDisplayYn: boolean;
  cautionsDisplayYn: boolean;
  infosDividerDisplayYn: boolean;
  infoAndCautionDisplayYn: boolean;
  isEndedDisplayYn: boolean;
  myCreditDisplayYn: boolean;
  participantsCnt: string;
  entryCredit: string;
  typeText?: string;
  isUntilRemainingHourDisplayYn: boolean;
  untilRemainingHour: number;
  isRemainingCountDisplayYn: boolean;
  remainingCount: number;
}

export const entryWebviewMapper = (
  data?: Partial<EntryDto>,
): EntryWebviewTemplate => {
  const dday = dayjs(data?.endedAt)
    .startOf('D')
    .diff(dayjs().startOf('D'), 'days');

  return {
    ...data,
    title: data?.title || '제목을 입력해주세요.',
    contents: data?.contents || '내용을 입력해주세요.',
    startedAt: dayjs(data?.startedAt).format('YYYY.MM.DD'),
    endedAt: dayjs(data?.endedAt).locale(ko).format('YYYY.MM.DD a HH:mm'),
    participantsCnt:
      typeof data?.participantsCnt === 'number'
        ? data?.participantsCnt.toLocaleString()
        : '1,000',
    entryCredit: `${data?.entryCredit ? `${data.entryCredit.toLocaleString()}C` : '무료'}`,
    ddayText: dday > 0 ? `${dday}일 남음` : '오늘 마감',
    myCredit: '10,000C',
    myCreditDisplayYn: true,
    thumbnailImageBufferFullUrl: data?.thumbnailImage?.bufferFullUrl || '',
    sponsorImageBufferFullUrl: data?.sponsorImage?.bufferFullUrl || '',
    infosList: data?.entryInfos
      ? data?.entryInfos?.map(item => `<li>${item.contents}</li>`).join('')
      : '',
    cautionsList: data?.entryCautions
      ? data?.entryCautions?.map(item => `<li>${item.contents}</li>`).join('')
      : '',
    ddayTextDisplayYn: !(dday < 0),
    thumbnailImageBufferFullUrlDisplayYn: !!data?.thumbnailImage?.bufferFullUrl,
    subTitleDisplayYn: !!data?.subTitle,
    sponsorDividerDisplayYn:
      !!data?.sponsorImage?.bufferFullUrl ||
      !!data?.sponsorDescription ||
      !!data?.sponsorLink,
    sponsorImageBufferFullUrlDisplayYn: !!data?.sponsorImage?.bufferFullUrl,
    sponsorDescriptionDisplayYn: !!data?.sponsorDescription,
    sponsorPageLinkDisplayYn: !!data?.sponsorLink,
    infosDisplayYn: (data?.entryInfos?.length || 0) > 0,
    cautionsDisplayYn: (data?.entryCautions?.length || 0) > 0,
    infosDividerDisplayYn:
      (data?.entryInfos?.length || 0) > 0 &&
      (data?.entryCautions?.length || 0) > 0,
    infoAndCautionDisplayYn:
      (data?.entryInfos?.length || 0) > 0 ||
      (data?.entryCautions?.length || 0) > 0,
    bottomButtonDisplayYn:
      !!data?.bottomButtonDisplayYn &&
      !!data?.bottomButtonName &&
      !!data?.bottomButtonLink,
    isEndedDisplayYn: dayjs(data?.endedAt).isBefore(dayjs(), 'days'),
    typeText: renderTypeText(data?.type),
    isUntilRemainingHourDisplayYn: data?.type === 'DAILY',
    untilRemainingHour: dayjs()
      .add(1, 'day')
      .startOf('day')
      .diff(dayjs(), 'hour'),
    isRemainingCountDisplayYn: data?.type === 'FIRST_SERVED',
    remainingCount: data?.firstServedRemainCnt || 0,
  };
};

const renderTypeText = (type?: string) => {
  switch (type) {
    case 'DAILY':
      return '매일 참여';
    case 'NORMAL':
      return '이벤트';
    case 'FIRST_SERVED':
      return '선착순';
    case 'FREE':
      return '무료';
    default:
      return '';
  }
};
